import React from "react";
import clsx from "clsx";

import { Spinner } from "@jasperlabs/ui";

type Props = {
	className?: string;
	variant?: "page" | "placeholder";
};

const LoadingPlaceholder = ({
	className,
	variant = "page",
	...props
}: Props) => (
	<div
		className={clsx(
			"flex w-full items-center justify-center",
			variant === "page" && ["h-screen"],
			variant === "placeholder" && ["h-full"],
			className,
		)}
		{...props}
	>
		<div>
			<Spinner size="lg" />
		</div>
	</div>
);

export default LoadingPlaceholder;
